import React, { useState, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import '../styles/LoginPage.scss';

const LoginPage = () => {
    const { loginUser, message } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await loginUser(e);
        setLoading(false);
    };

    return (
        <div className="login-page d-flex flex-column justify-content-center align-items-center">
            <div className="login-card">
                <h2>Cable One Networks</h2>
                {message && <div className={`alert ${message.type}`}>{message.text}</div>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Username</label>
                        <input
                            type="text"
                            name="username"
                            placeholder="Enter your username"
                            disabled={loading}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            name="password"
                            placeholder="Enter your password"
                            disabled={loading}
                            required
                        />
                    </div>
                    <button type="submit" disabled={loading}>
                        {loading ? <span className="spinner"></span> : 'Login'}
                    </button>
                </form>
            </div>
            
            <div className="footer text-white mt-4">
                <small>&copy; 2025 Cable One Networks. All rights reserved.</small>    
            </div> 
        </div>
    );
};

export default LoginPage;
